<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container">
      <router-link :to="{ name: user ? 'home' : 'welcome' }" class="navbar-brand">
        <!--{{ appName }}-->
        <img src="/img/logo_one_world.png" style="height: 50px;"><span>App</span>
      </router-link>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler"
              aria-controls="navbarToggler" aria-expanded="false">
        <span class="navbar-toggler-icon"/>
      </button>

      <div id="navbarToggler" class="collapse navbar-collapse">
        <ul class="navbar-nav">
          <locale-dropdown/>
          <li v-if="user" class="nav-item dropdown">
            <a data-toggle="dropdown" class="nav-link dropdown-toggle" :class="{'active': subIsActive('/anagrafiche')}"> {{ $t('records') }}</a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'anagrafiche.impianti' }" class="nav-link" active-class="active">{{
                $t('recordsINSTALLATIONS') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.clienti' }" class="nav-link" active-class="active"> {{
                $t('recordsCUSTOMER') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.articoli' }" class="nav-link" active-class="active">{{
                $t('recordsARTICLES') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.vettori' }" class="nav-link" active-class="active">{{
                $t('recordsCARRIERS') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.ubicazioni' }" class="nav-link" active-class="active">{{
                $t('recordsLOCATIONS') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.utenti' }" class="nav-link" active-class="active">{{
                $t('recordsUSERS') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.tipologia_documenti' }" class="nav-link" active-class="active">{{
                $t('recordsTYPEDOCUMENTS') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.tipologia_picking' }" class="nav-link" active-class="active">{{
                $t('recordsTYPEPIKING') }}
              </router-link>
              <router-link :to="{ name: 'anagrafiche.tipologia_stock' }" class="nav-link" active-class="active">{{
                $t('recordsTYPESTOCK') }}
              </router-link>
            </div>
            <div class="dropdown-menu">
            </div>
          </li>

          <li v-if="user" class="nav-item">
            <router-link :to="{ name: 'gestione.magazzino' }" class="nav-link" active-class="active"> {{
              $t('warehouse') }}
            </router-link>
          </li>

          <li v-if="user" class="nav-item">
            <router-link :to="{ name: 'gestione.magazzino_ingressi' }" class="nav-link" active-class="active"> {{
              $t('input') }}
            </router-link>
          </li>

          <li v-if="user" class="nav-item">
            <router-link :to="{ name: 'gestione.magazzino_uscite' }" class="nav-link" active-class="active"> {{
              $t('output') }}
            </router-link>
          </li>

          <li v-if="user" class="nav-item dropdown">
            <a data-toggle="dropdown" class="nav-link dropdown-toggle" :class="{'active': subIsActive('/gestione/spedizioni')}"> {{ $t('expeditions') }}</a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'gestione.spedizioni_in_attesa' }" class="nav-link" active-class="active">{{
                $t('expeditionsWAIT') }}
              </router-link>
              <router-link :to="{ name: 'gestione.spedizioni' }" class="nav-link" active-class="active"> {{
                $t('expeditionsNEW') }}
              </router-link>

              <router-link :to="{ name: 'gestione.spedizioni_archivio' }" class="nav-link" active-class="active"> {{
                $t('expeditionsARCHIVE') }}
              </router-link>

              <router-link :to="{ name: 'gestione.spedizioni_archivio_modifica' }" class="nav-link" active-class="active"> {{
                $t('expeditionsEDIT') }}
              </router-link>

              <router-link :to="{ name: 'gestione.conferma_trasmissione_edi' }" class="nav-link" active-class="active"> {{
                $t('expeditionsTRASMISSIONCONFIRM') }}
              </router-link>

            </div>
            <div class="dropdown-menu">
            </div>
          </li>

          <li v-if="user" class="nav-item dropdown">
            <a data-toggle="dropdown" class="nav-link dropdown-toggle" :class="{'active': subIsActive('/statistiche')}"> {{ $t('statistics') }}</a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'statistiche.entrate' }" class="nav-link" active-class="active">{{
                $t('statisticsENTER') }}
              </router-link>
              <router-link :to="{ name: 'statistiche.uscite' }" class="nav-link" active-class="active"> {{
                $t('statisticsEXIT') }}
              </router-link>

            </div>
            <div class="dropdown-menu">
            </div>
          </li>


        </ul>

        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <li v-if="user" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle text-dark"
               href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img :src="user.photo_url" class="rounded-circle profile-photo mr-1">
              {{ user.name }}
            </a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'settings.profile' }" class="dropdown-item pl-3">
                <fa icon="cog" fixed-width/>
                {{ $t('settings') }}
              </router-link>
              <Developer>
              </Developer>
              <div class="dropdown-divider"/>
              <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                <fa icon="sign-out-alt" fixed-width/>
                {{ $t('logout') }}
              </a>
            </div>
          </li>
          <!-- Guest -->
          <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'register' }" class="nav-link" active-class="active">
                {{ $t('register') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  import {mapGetters} from 'vuex'
  import LocaleDropdown from '../LocaleDropdown'
  import Developer from '../Developer'

  export default {
    components: {
      LocaleDropdown,
      Developer
    },

    data: () => ({
      appName: window.config.appName
    }),

    computed: mapGetters({
      user: 'auth/user',
    }),

    methods: {
      async logout() {
        // Log out the user.
        await this.$store.dispatch('auth/logout')

        // Redirect to login.
        this.$router.push({name: 'login'})
      },

      subIsActive(input) {
        const paths = Array.isArray(input) ? input : [input];
        return paths.some(path => {
          return this.$route.path.indexOf(path) === 0 // current path starts with this path string
        })
      }
    },
  }
</script>

<style scoped>
  .profile-photo {
    width: 2rem;
    height: 2rem;
    margin: -.375rem 0;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/menu/NavbarAdmin.vue